// extracted by mini-css-extract-plugin
module.exports = {"tileBoard":"Tiles_tile-board__w4B8k","tile":"Tiles_tile__1Fy5M","tileTrans":"Tiles_tile--trans__1kjHk"};